import { IconName } from '@as/cotopaxi';
import { isPossiblePhoneNumber } from '@yonderland/andes-react';
import { CountryId, DefaultSettings, DeliveryOptionsEnum, ErrorMessage, } from '@as-react/common-types';
import { capitalizeOnly, isNullOrUndefined } from '@as-react/common-utils';
import CustomerUtil from './CustomerUtil';
export const generateFieldName = (name, prefix) => prefix ? `${prefix}${prefix.endsWith('.') ? name : capitalizeOnly(name)}` : name;
export const isDaysOption = (deliveryOption) => [DeliveryOptionsEnum.NAMED_DAY, DeliveryOptionsEnum.NEXT_DAY, DeliveryOptionsEnum.HOME_DELIVERY].includes(deliveryOption);
export const getHouseNumberNLPattern = (value) => new RegExp('^[A-Z]{1}', 'i').test(value) ? DefaultSettings.HOUSE_NUMBER_NL_ALPHA : DefaultSettings.HOUSE_NUMBER_NL;
export const isUkCountry = (country) => ['GB', 'GG', 'JE'].includes(country);
export const isValidateInvoicePart = (isInvoiceEnabled, isEnableFullVatForm, values) => {
    if (!isInvoiceEnabled) {
        return false;
    }
    return (isEnableFullVatForm && values.needInvoice) || (!isEnableFullVatForm && values.alternateInvoiceAddress);
};
export const validateCustomerFields = (values, t) => {
    const errors = {};
    if (!values.idTitle) {
        errors.idTitle = t(ErrorMessage.REQUIRED);
    }
    if (!values.firstName) {
        errors.firstName = t(ErrorMessage.REQUIRED);
    }
    if (!values.lastName) {
        errors.lastName = t(ErrorMessage.REQUIRED);
    }
    return errors;
};
export const validatePhoneNumber = (phoneNumber = '', requiresPhoneNumber = false, t, prefix) => {
    if (requiresPhoneNumber && !phoneNumber) {
        return { [generateFieldName('phoneNumber', prefix)]: t(ErrorMessage.REQUIRED) };
    }
    else if (phoneNumber && !isPossiblePhoneNumber(phoneNumber)) {
        return { [generateFieldName('phoneNumber', prefix)]: t(ErrorMessage.INVALID_PHONE) };
    }
    else {
        return {};
    }
};
export const validateAddressFields = (values, t, country, prefix, showPhoneNumber, states, requiresPhoneNumber) => {
    let errors = {};
    if (showPhoneNumber) {
        errors = Object.assign(Object.assign({}, errors), validatePhoneNumber(values === null || values === void 0 ? void 0 : values.phoneNumber, requiresPhoneNumber, t, prefix));
    }
    switch (country) {
        case 'NL':
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (!new RegExp(DefaultSettings.POSTAL_CODE_NL, 'i').test(values[generateFieldName('postCode', prefix)])) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.INVALID_POSTAL_CODE_NL);
            }
            if (!values[generateFieldName('houseNumber', prefix)]) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (!new RegExp(getHouseNumberNLPattern(values[generateFieldName('houseNumber', prefix)]), 'i').test(values[generateFieldName('houseNumber', prefix)])) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.INVALID_HOUSE_NUMBER_NL);
            }
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (!new RegExp(DefaultSettings.STREET_NAME_REGEX).test(values[generateFieldName('address', prefix)])) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.INVALID_STREET);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'DE':
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (values[generateFieldName('address', prefix)] &&
                !new RegExp(DefaultSettings.STREET_NAME_REGEX).test(values[generateFieldName('address', prefix)])) {
                errors[generateFieldName('address', prefix)] = t('buy:buy.error.addressfields.streetName.invalid');
            }
            if (!values[generateFieldName('houseNumber', prefix)]) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'FR':
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (values[generateFieldName('address', prefix)] &&
                !new RegExp(DefaultSettings.STREET_NAME_REGEX).test(values[generateFieldName('address', prefix)])) {
                errors[generateFieldName('address', prefix)] = t('buy:buy.error.addressfields.streetName.invalid');
            }
            if (!values[generateFieldName('houseNumber', prefix)]) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'US':
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (states && !values[generateFieldName('state', prefix)]) {
                errors[generateFieldName('state', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'BE':
        case 'LU':
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (values[generateFieldName('address', prefix)] &&
                !new RegExp(DefaultSettings.STREET_BE_LU_REGEXP).test(values[generateFieldName('address', prefix)])) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.INVALID_STREET_BE_LU);
            }
            if (!values[generateFieldName('houseNumber', prefix)]) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (values[generateFieldName('houseNumber', prefix)] &&
                !new RegExp(DefaultSettings.HOUSE_NUMBER_BE_LU_REGEXP).test(values[generateFieldName('houseNumber', prefix)])) {
                errors[generateFieldName('houseNumber', prefix)] = t(ErrorMessage.INVALID_HOUSE_NUMBER_BE_LU);
            }
            if (values[generateFieldName('houseNumberAddition', prefix)] &&
                !new RegExp(DefaultSettings.HOUSE_NUMBER_ADDITION_BE_LU_REGEXP).test(values[generateFieldName('houseNumberAddition', prefix)])) {
                errors[generateFieldName('houseNumberAddition', prefix)] = t(ErrorMessage.INVALID_HOUSE_NUMBER_ADDITION_BE_LU);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (country === 'LU' &&
                values[generateFieldName('postCode', prefix)].length < DefaultSettings.MIN_LENGTH_POST_CODE) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.MIN_LENGTH);
            }
            else if (country === 'BE' &&
                !new RegExp(DefaultSettings.POSTAL_CODE_BE, 'i').test(values[generateFieldName('postCode', prefix)])) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.INVALID_POSTAL_CODE_BE);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'GB':
        case 'GG':
        case 'JE':
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (!new RegExp(DefaultSettings.STREET_NAME_REGEX).test(values[generateFieldName('address', prefix)])) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.INVALID_STREET);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
            else if (!new RegExp(DefaultSettings.POSTAL_CODE_UK).test(values[generateFieldName('postCode', prefix)])) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.INVALID_POSTAL_CODE_UK);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            break;
        case 'BFPO':
        case 'IE':
        case 'AU':
        case 'NZ':
        default:
            if (!values[generateFieldName('address', prefix)]) {
                errors[generateFieldName('address', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('city', prefix)]) {
                errors[generateFieldName('city', prefix)] = t(ErrorMessage.REQUIRED);
            }
            if (!values[generateFieldName('postCode', prefix)]) {
                errors[generateFieldName('postCode', prefix)] = t(ErrorMessage.REQUIRED);
            }
    }
    return errors;
};
export const getDeliveryOptionIconName = (optionName) => {
    switch (optionName) {
        case DeliveryOptionsEnum.COLLECT_HQ:
            return IconName.COMMERCIAL_BUILDING;
        case DeliveryOptionsEnum.COLLECT_STORE:
            return IconName.STORE;
        case DeliveryOptionsEnum.HOME_DELIVERY:
        case DeliveryOptionsEnum.NAMED_DAY:
        case DeliveryOptionsEnum.NEXT_DAY:
            return IconName.HOME;
        case DeliveryOptionsEnum.PICKUP_POINT:
        default:
            return IconName.MAP_MARKER;
    }
};
export const getInitialValues = (delivery, initValues, optionName, addressPrefix, addressPrefilled = true, addressEdit = false, prefillProfilePhoneNumber = false) => {
    if (!delivery.customerDetails) {
        return initValues;
    }
    let address = addressPrefilled &&
        (optionName === DeliveryOptionsEnum.PICKUP_POINT ? delivery.customerDetails.address : delivery.deliveryAddress);
    if (addressEdit) {
        address = delivery.deliveryAddress;
    }
    let initialValues = Object.assign(Object.assign({}, initValues), address);
    if (![CountryId.NL, CountryId.BE, CountryId.LU, CountryId.FR].includes(delivery.idCountry)) {
        initialValues.houseNumberAddition = '';
    }
    if (![CountryId.NL, CountryId.BE, CountryId.LU, CountryId.DE, CountryId.FR].includes(delivery.idCountry)) {
        initialValues.houseNumber = '';
    }
    if ([CountryId.NL, CountryId.BE, CountryId.LU, CountryId.DE, CountryId.FR].includes(delivery.idCountry)) {
        initialValues.addressLine2 = '';
    }
    if (CountryId.US !== delivery.idCountry) {
        initialValues.state = '';
    }
    if (![CountryId.GB, CountryId.GG, CountryId.JE].includes(delivery.idCountry)) {
        initialValues.addressLine3 = '';
    }
    if (addressPrefix && delivery.customerDetails) {
        const addressWithPrefix = {};
        if (delivery.customerDetails.address) {
            for (const [key, value] of Object.entries(delivery.customerDetails.address)) {
                addressWithPrefix[`${addressPrefix}${capitalizeOnly(key)}`] = value;
            }
        }
        if (delivery.customerDetails.vatNumber) {
            addressWithPrefix[`${addressPrefix}${capitalizeOnly('vatNumber')}`] = delivery.customerDetails.vatNumber;
        }
        if (delivery.customerDetails.companyName) {
            addressWithPrefix[`${addressPrefix}${capitalizeOnly('companyName')}`] = delivery.customerDetails.companyName;
        }
        if (delivery.customerDetails.companyDepartment) {
            addressWithPrefix[`${addressPrefix}${capitalizeOnly('companyDepartment')}`] =
                delivery.customerDetails.companyDepartment;
        }
        initialValues = Object.assign(Object.assign({}, initialValues), addressWithPrefix);
    }
    initialValues = Object.assign(Object.assign({}, initialValues), CustomerUtil.getCustomerNames(delivery, optionName));
    if (!isNullOrUndefined(delivery.deliveryAddress.phoneNumber)) {
        initialValues = Object.assign(Object.assign({}, initialValues), { phoneNumber: CustomerUtil.convertPhoneNumberPrefix(delivery.deliveryAddress.phoneNumber, '00', '+') });
    }
    else if (prefillProfilePhoneNumber && delivery.customerDetails.mobilePhoneNumber) {
        initialValues = Object.assign(Object.assign({}, initialValues), { phoneNumber: CustomerUtil.convertPhoneNumberPrefix(delivery.customerDetails.mobilePhoneNumber, '00', '+') });
    }
    return initialValues;
};
export const findUSStateByName = (states, name) => states === null || states === void 0 ? void 0 : states.find(st => name === st.name);
export const findUSStateByCounty = (states, deliveryAddress) => states === null || states === void 0 ? void 0 : states.find(st => (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.idCountry) === st.countryId && (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.county) === st.name);
export const findUSStateByStateIso = (states, deliveryAddress) => states === null || states === void 0 ? void 0 : states.find(st => deliveryAddress.idCountry === st.countryId && deliveryAddress.stateIso === st.abbreviation);
export const isNextOrNamedDayOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY || opt.name === DeliveryOptionsEnum.NEXT_DAY) {
            countOptions++;
        }
    });
    return countOptions === 2;
};
export const isNamedDayOrHomeDeliveryOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY || opt.name === DeliveryOptionsEnum.HOME_DELIVERY) {
            countOptions++;
        }
    });
    return countOptions === 2;
};
export const isAllDaysOptions = (deliveryOptions) => {
    let countOptions = 0;
    deliveryOptions.forEach(opt => {
        if (opt.name === DeliveryOptionsEnum.NAMED_DAY ||
            opt.name === DeliveryOptionsEnum.NEXT_DAY ||
            opt.name === DeliveryOptionsEnum.HOME_DELIVERY) {
            countOptions++;
        }
    });
    return countOptions === 3;
};
export const chooseDeliveryOption = (deliveryOptions, deliveryOption) => isDaysOption(deliveryOption) &&
    (isNextOrNamedDayOptions(deliveryOptions) ||
        isNamedDayOrHomeDeliveryOptions(deliveryOptions) ||
        isAllDaysOptions(deliveryOptions))
    ? DeliveryOptionsEnum.NAMED_DAY
    : deliveryOption;
export const filterDeliveryOptions = (deliveryOptions) => {
    if (isNextOrNamedDayOptions(deliveryOptions) ||
        isNamedDayOrHomeDeliveryOptions(deliveryOptions) ||
        isAllDaysOptions(deliveryOptions)) {
        return deliveryOptions.filter(opt => opt.name !== DeliveryOptionsEnum.NEXT_DAY && opt.name !== DeliveryOptionsEnum.HOME_DELIVERY);
    }
    return deliveryOptions;
};
export const showNamedDays = (option) => option.name === DeliveryOptionsEnum.NAMED_DAY ||
    (option.name === DeliveryOptionsEnum.NEXT_DAY && option.namedDayEnabled);
export const getDefaultCountry = (fictiveWebShop) => {
    switch (fictiveWebShop) {
        case '139':
            return 'IE';
        case '142':
            return 'US';
        case '145':
            return 'AU';
        default:
            return 'GB';
    }
};
export const isValidAddress = (postCode, houseNumber, country) => {
    switch (country) {
        case 'NL':
            return (!!postCode &&
                !!houseNumber &&
                new RegExp(DefaultSettings.POSTAL_CODE_NL, 'i').test(postCode) &&
                new RegExp(getHouseNumberNLPattern(houseNumber), 'i').test(houseNumber));
        case 'BE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_BE, 'i').test(postCode);
        case 'GB':
        case 'GG':
        case 'JE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_UK).test(postCode);
        default:
            return true;
    }
};
export const isValidPostCode = (postCode, country) => {
    switch (country) {
        case 'BE':
            return !!postCode && new RegExp(DefaultSettings.POSTAL_CODE_BE, 'i').test(postCode);
        case 'DE':
        case 'FR':
            return !!postCode && postCode.length === 5;
        default:
            return true;
    }
};
